import React from 'react';
import { useSelector } from "react-redux";
import { format, isValid } from 'date-fns';

const profileFieldMap = {
  "Date of Birth": "date_of_birth",
  "Blood Group": "blood_group_cd",
  "Hobbies": "hobbies",
  "Education History": "education_history",
  "Programming Languages": "programming_languages_cd"
};

const UserProfile = ({ profileField, setProfileField, setProfileValues }) => {
  const profileData = useSelector((state) => state.profile.profile.data); // Adjust as needed

  const handleChange = (e) => {
    const fieldKey = e.target.value;
    setProfileField(fieldKey);

    if (profileData && Array.isArray(profileData)) {
      const values = profileData.map((user) => {
        const value = user[fieldKey];

        let formattedValue;
        if (fieldKey === "date_of_birth" && isValid(new Date(value))) {
          formattedValue = format(new Date(value), 'yyyy-MM-dd');
        } else {
          formattedValue = value ?? " ";
        }

        return {
          id: user.t_user_id,
          fieldname:fieldKey,
          value: formattedValue
        };
      });

      setProfileValues(values);

      setProfileValues(values);
    } else {
      setProfileValues("No data available");
    }

  };

  return (
    <div>
      <select name="profile" value={profileField} onChange={handleChange}>
        <option value="">-- Select Profile Field --</option>
        {Object.entries(profileFieldMap).map(([label, key]) => (
          <option key={key} value={key}>{label}</option>
        ))}
      </select>
    </div>
  );
};

export default UserProfile;

